import { renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e4b0e4c")

_pushScopeId("data-v-3e4b0e4c")
const _hoisted_1 = {
  key: 0,
  class: "el-icon-caret-bottom"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_popover = _resolveComponent("el-popover")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_popover, {
      placement: _ctx.placement,
      width: 200,
      visible: _ctx.showPop
    }, {
      reference: _withId(() => [
        _createVNode("span", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changePop && _ctx.changePop(...args)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.name) + " ", 1),
          (_ctx.isShowIcon)
            ? (_openBlock(), _createBlock("i", _hoisted_1))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", null, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["placement", "visible"])
  ]))
})